<app-report-header
  class="d-none d-print-block"
  [routeName]="route.name"
></app-report-header>

<app-report-summary
  class="d-none d-print-block mt-3"
  [route]="route"
></app-report-summary>

<h4 class="d-none d-print-block">Toll Type Report</h4>
<div class="scroll-modal">
  <table class="tollTable table" id="toll-type-table">
    <thead class="bg-gray-light">
      <tr>
        <th class="border-top-0">Country</th>
        <th class="border-top-0">Road</th>
        <th class="border-top-0">Toll Name</th>
        <th class="border-top-0">Distance Based</th>
        <th class="border-top-0">Pass</th>
        <th class="border-top-0 text-right">Flat</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let segmentLine of segmentLines; let k = index">
        <tr>
          <td>{{ segmentLine.Country }}</td>
          <td>
            {{ segmentLine.Road }}
          </td>
          <td>
            {{ segmentLine.TollName }}
          </td>
          <td>
            {{ segmentLine.DistanceBased }}
          </td>
          <td>
            {{ segmentLine.Pass }}
          </td>
          <td class="text-right">
            {{
              segmentLine.Flat !== ""
                ? (segmentLine.Flat | number : "1.1-1")
                : ("0.00" | number : "1.1-1")
            }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <table class="tollTable table" id="toll-type-table">
    <thead class="bg-gray-light">
      <tr>
        <th class="border-top-0">Country</th>
        <th class="border-top-0">Toll Type</th>
        <th class="border-top-0">Toll Name</th>
        <th class="border-top-0">Toll Distance</th>
        <th class="border-top-0 text-right">Tolls Local</th>
        <th class="border-top-0 text-right">Tolls in Euros</th>
        <th class="border-top-0">Payment Option</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let summaryLine of summaryLines; let k = index">
        <tr>
          <td>{{ summaryLine.Country }}</td>
          <td>
            {{ summaryLine.TollType }}
          </td>
          <td>
            {{ summaryLine.TollName }}
          </td>
          <td>
            {{ summaryLine.TollDistance }}
          </td>
          <td class="text-right">
            {{ summaryLine.TollsLocal }}
          </td>
          <td class="text-right">
            {{ summaryLine.Tolls }}
          </td>
          <td>
            {{ summaryLine.PaymentOption }}
          </td>
        </tr>
      </ng-container>
      <tr>
        <td class="font-weight-bold">Total</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="font-weight-bold text-right">
          {{ total | number : "1.1-2" }}
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <app-show-data-version [route]="route"></app-show-data-version>
</div>
